import { render } from "./gate-sales.vue?vue&type=template&id=01d88102"
import script from "./gate-sales.vue?vue&type=script&lang=js"
export * from "./gate-sales.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__